var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWhatsapp = function SvgIconWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "icon_whatsapp_svg__Layer_1",
    width: "1em",
    height: "1em",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon_whatsapp_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 45.2 3-10.8C4.1 31.2 3.2 27.6 3.2 24 3.2 12.5 12.5 3.1 24 3.1c5.6 0 10.8 2.2 14.8 6.1 3.9 3.9 6.1 9.2 6.1 14.8 0 11.5-9.4 20.9-20.9 20.9-3.5 0-6.9-.9-10-2.5z",
    className: "icon_whatsapp_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 45.8c-.1 0-.3-.1-.4-.2s-.2-.3-.1-.5l2.9-10.6C3.6 31.3 2.6 27.6 2.6 24 2.6 12.2 12.2 2.6 24 2.6c5.7 0 11.1 2.2 15.2 6.3 4 4 6.3 9.4 6.3 15.1 0 11.8-9.6 21.4-21.4 21.4-3.5 0-7-.9-10.1-2.5L3.1 45.7z",
    className: "icon_whatsapp_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 3.1c5.6 0 10.8 2.2 14.8 6.1 3.9 3.9 6.1 9.2 6.1 14.8 0 11.5-9.4 20.9-20.9 20.9-3.5 0-6.9-.9-10-2.5L3 45.2l3-10.8C4.1 31.2 3.2 27.6 3.2 24 3.2 12.5 12.5 3.1 24 3.1M24 2C11.9 2 2 11.9 2 24c0 3.7.9 7.3 2.7 10.6L1.9 44.9c-.1.4 0 .8.3 1.1.2.2.5.3.8.3h.3l10.6-2.8C17 45.1 20.5 46 24 46c12.1 0 22-9.9 22-22 0-5.9-2.3-11.4-6.4-15.5C35.4 4.3 29.9 2 24 2",
    style: {
      fill: "#cfd8dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3 11.7C33 8.4 28.7 6.6 24 6.6 14.5 6.6 6.7 14.4 6.7 24c0 3.3.9 6.5 2.7 9.2l.4.7L8 40.2l6.6-1.7.6.4c2.7 1.6 5.7 2.4 8.8 2.4 9.6 0 17.3-7.8 17.3-17.3.1-4.7-1.7-9-5-12.3",
    style: {
      fill: "#40c351"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8 15.2c-.4-.9-.8-.9-1.2-.9h-1c-.3 0-.9.1-1.4.7-.5.5-1.8 1.8-1.8 4.3s1.9 5 2.1 5.4c.3.3 3.6 5.8 8.9 7.9 4.4 1.7 5.3 1.4 6.3 1.3s3.1-1.3 3.5-2.5.4-2.3.3-2.5-.5-.3-1-.6-3.1-1.5-3.6-1.7-.8-.3-1.2.3c-.3.5-1.3 1.7-1.7 2-.3.3-.6.4-1.1.1s-2.2-.8-4.2-2.6c-1.5-1.4-2.6-3.1-2.9-3.6s0-.8.2-1.1c.2-.2.5-.6.8-.9s.3-.5.5-.9c.2-.3.1-.7 0-.9 0-.1-1-2.7-1.5-3.8",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }));
};
export default SvgIconWhatsapp;